/**
 * contains the abi and contract address
*/

class EncryptionContract {
    constructor() {
        this.abi = [
	{
		"constant": false,
		"inputs": [
			{
				"name": "sharedWith",
				"type": "address"
			},
			{
				"name": "contentHash",
				"type": "bytes32"
			},
			{
				"name": "encryptedContentKey",
				"type": "bytes32[9]"
			},
			{
				"name": "publicKey",
				"type": "bytes32[6]"
			}
		],
		"name": "shareEncryptedContentWith",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "publicKey",
				"type": "bytes32[6]"
			}
		],
		"name": "setPublicKey",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"name": "previousContentHash",
				"type": "bytes32"
			},
			{
				"name": "newContentHash",
				"type": "bytes32"
			},
			{
				"name": "encryptedName",
				"type": "bytes32"
			},
			{
				"name": "contentType",
				"type": "int8"
			},
			{
				"name": "encryptedContentKey",
				"type": "bytes32[9]"
			},
			{
				"name": "publicKey",
				"type": "bytes32[6]"
			}
		],
		"name": "newEncryptedContent",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [],
		"name": "hasPublicKey",
		"outputs": [
			{
				"name": "",
				"type": "bool"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "user",
				"type": "address"
			},
			{
				"indexed": false,
				"name": "publicKey",
				"type": "bytes32[6]"
			}
		],
		"name": "NewPublicKey",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "user",
				"type": "address"
			},
			{
				"indexed": false,
				"name": "previousContent",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"name": "newContent",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"name": "contentType",
				"type": "int8"
			},
			{
				"indexed": false,
				"name": "encryptedName",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"name": "contentKey",
				"type": "bytes32[9]"
			},
			{
				"indexed": false,
				"name": "publicKey",
				"type": "bytes32[6]"
			}
		],
		"name": "NewEncryptedContent",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"name": "sharedWith",
				"type": "address"
			},
			{
				"indexed": true,
				"name": "creator",
				"type": "address"
			},
			{
				"indexed": true,
				"name": "contentHash",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"name": "contentKey",
				"type": "bytes32[9]"
			},
			{
				"indexed": false,
				"name": "publicKey",
				"type": "bytes32[6]"
			}
		],
		"name": "EncryptedContentShared",
		"type": "event"
	}
        ];        
        this.contractAddress = '0xbe559f9f38c5f36186b364972cb8b4ebd7174043';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default EncryptionContract;
